import React, { useState } from "react";
import Popup from "reactjs-popup";
import { FacebookShareButton, PinterestShareButton, TwitterShareButton } from "react-share";
import { colors } from "styles/colors";
import { Icon } from "components/SvgIcons";
import { ItemBtnGroup } from "shared/BtnsGroup/styled";
import Button from "shared/Button";
import { BtnToolColumn, BtnTool, SocialItemsWrap, SocialItem, Copied, BtnToolbarItemRecipe } from "./styled";
import { getBaseURL } from "helpers";

import { useRenderDevice } from "helpers/hooks/useRenderDevice";

export const PopupSocial = ({ item, socialImgUrl, isRecipe, mealPlanId, recipeId }) => {
  const isMobile = useRenderDevice({ max: 769 });

  const url = typeof window !== "undefined" && window.location.href;
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    if (isRecipe && recipeId) {
      const urlRecipe = `mobile/recipes/${recipeId}`;
      let urlUpdate = getBaseURL() + urlRecipe;
      navigator.clipboard.writeText(urlUpdate);
    } else if (!isRecipe && mealPlanId) {
      const urlUpdate = `mobile/foody-weeks/${mealPlanId}`;
      let url = getBaseURL() + urlUpdate;
      navigator.clipboard.writeText(url);
    } else {
      navigator.clipboard.writeText(url);
    }

    setCopied(!copied);
    setTimeout(() => {
      setCopied(copied);
    }, 1500);
  };

  return (
    <Popup
      trigger={
        isRecipe ? (
          <BtnToolbarItemRecipe>
            <Icon icon={item.icon} />
          </BtnToolbarItemRecipe>
        ) : isMobile ? (
          <ItemBtnGroup>
            <Button
              color={colors.WHITE}
              textColor={colors.GREY_DARK}
              stylType="outline"
              text={item.name}
              iconRight={item.icon}
            />
          </ItemBtnGroup>
        ) : (
          <BtnToolColumn>
            <BtnTool>
              <Icon icon={item.icon} />
              {item.name}
            </BtnTool>
          </BtnToolColumn>
        )
      }
      position="bottom center"
      arrowStyle={{ color: "transparent" }}
    >
      <SocialItemsWrap>
        <SocialItem color={colors.GREY_DARK} onClick={copyToClipboard}>
          <Icon icon="share_link" />
          Copy link
        </SocialItem>
        {copied && <Copied color={colors.GREY_DARK}>Copied!</Copied>}
        <PinterestShareButton media={socialImgUrl} url={url}>
          <SocialItem color={colors.PINK_2}>
            <Icon icon="pinterest_2" />
            Pinterest
          </SocialItem>
        </PinterestShareButton>
        <FacebookShareButton url={url}>
          <SocialItem color={colors.BLUE_100}>
            <Icon icon="fb_2" />
            Facebook
          </SocialItem>
        </FacebookShareButton>
        <TwitterShareButton url={url}>
          <SocialItem color={colors.BLUE_200}>
            <Icon icon="twitter_2" />
            Twitter
          </SocialItem>
        </TwitterShareButton>
      </SocialItemsWrap>
    </Popup>
  );
};
